import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { A, H4, P } from 'components/Typography';
import Modal from 'components/Modal';
import StepOne from './components/StepOne';
import StepTwo from './components/StepTwo';
import StepThree from './components/StepThree';
import StepFour from './components/StepFour';
import {
  ClaimsContainer,
  ClaimDisclaimerText,
  Content,
  Divider,
  ModalCard,
  ModalText,
  ModalOpenLink
} from './styled';

const Claims = () => {
  const { contractsIncludingExpired } = useSelector(
    (state) => state.nomadInsurance.contract
  );
  const [isProcessModalOpen, setIsProcessModalOpen] = useState(false);
  const [isDelayModalOpen, setIsDelayModalOpen] = useState(false);

  const ProcessModal = () => {
    return (
      <Modal
        isOpen={isProcessModalOpen}
        onClose={() => setIsProcessModalOpen(false)}
        header="Follow the process online"
      >
        <ModalText>
          To follow your claims process online, you will need to set up a profile on{' '}
          <A href="https://worldtrips.my.site.com/MemberPortal">
            WorldTrips' Member Portal
          </A>
          , using your SafetyWing policy ID. Once you are logged in, you can find claims
          claims claims by clicking “Claims” in the top menu, and then “Letters” from the
          dropdown.
        </ModalText>
        <ModalText>
          Note that email updates will not be sent out. Please check here periodically, in
          case the claims team needs more information from you than provided in the form.
        </ModalText>
      </Modal>
    );
  };

  const DelayModal = () => {
    return (
      <Modal
        isOpen={isDelayModalOpen}
        onClose={() => setIsDelayModalOpen(false)}
        header="What if my claim has been delayed?"
      >
        <ModalText>
          Because there are a lot of moving parts and people involved in each step, about
          10% of claims processing has some kind of delay. The most typical reasons for a
          delay are:
          <ul>
            <li>Missing information in the claims form</li>
            <li>
              A communication problem between the claims department and the hospital
            </li>
            <li>
              It is unknown whether the incident was due to a pre-existing condition or
              not, which could require looking into your medical history
            </li>
          </ul>
        </ModalText>
        <ModalCard size="thin" variant="dark">
          <P>
            If more than 45 business days have passed and your claim has not been
            processed yet, please email us at{' '}
            <A href="mailto:claimsassistance@safetywing.com" variant="light">
              claimsassistance@safetywing.com
            </A>
            , and we will happily figure out what is stalling the process so that we can
            expedite it for you!
          </P>
        </ModalCard>
      </Modal>
    );
  };

  return (
    <ClaimsContainer>
      <H4>
        {contractsIncludingExpired?.length
          ? 'Need to submit a claim?'
          : 'What is the Nomad Insurance claim process like?'}
      </H4>
      <Content>
        <StepOne showStartButton={Boolean(contractsIncludingExpired?.length)} />
        <StepTwo />
        <StepThree handleModalOpen={() => setIsProcessModalOpen(true)} />
        <StepFour />
      </Content>
      <Divider />
      <ClaimDisclaimerText>
        All claims must be filed within 60 days following the termination of the
        insurance.
      </ClaimDisclaimerText>
      <ModalOpenLink onClick={() => setIsDelayModalOpen(true)}>
        What if my claim has been delayed?
      </ModalOpenLink>
      <ProcessModal />
      <DelayModal />
    </ClaimsContainer>
  );
};

export default Claims;
